import NeoLeoAvatar from '../../assets/img/neo-leo.png';
import { cn } from '../../utils/classUtils';

interface NeoLeoIconProps {
  handleNeoLeoToggle: () => void;
  neoLeoPanelOpened: boolean;
  notificationsLength: number;
}

const NeoLeoIcon: React.FC<NeoLeoIconProps> = ({
  handleNeoLeoToggle,
  neoLeoPanelOpened,
  notificationsLength,
}) => {
  return (
    <div className='w-28 flex items-start justify-start rounded-[12px] bg-gradient-to-b from-[#A5B4FC] to-[#C084FC] p-[1px]'>
      <div
        className={cn(
          'relative bg-reskin-regent-900 rounded-[11px] p-1.5 cursor-pointer flex items-center justify-start h-9 animate-leo-trigger-collapse w-28',
          // neoLeoPanelOpened
          //   ? 'animate-leo-trigger-collapse w-9'
          //   : 'animate-leo-trigger-expand pr-3 w-[106]',
        )}
        onClick={handleNeoLeoToggle}
        data-testid='neo-leo-button'
      >
        <img className='w-6 h-6' src={NeoLeoAvatar} alt='neo-leo-avatar' />
        <p className='text-white text-sm font-medium ml-1 font-inter'>
          Open Leo
        </p>
        {!neoLeoPanelOpened && !!notificationsLength && (
          <div className='absolute top-0 right-0 -mt-2 -mr-2 z-[41]'>
            <div className='w-5 h-5 bg-reskin-red-500 rounded-full flex items-center justify-center leading-5'>
              <span className='text-white text-xs font-semibold mt-0.5'>
                {notificationsLength > 9 ? '9+' : notificationsLength}
              </span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default NeoLeoIcon;
